<template>
    <div>
      <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout">
        <a-form-model-item
            ref="name"
            label="功能名称"
            prop="name"
            :help="formErr.name"
            :validateStatus='!formErr.name||formErr.name==""?"":"error"'
        >
          <a-input
              :maxLength=20
              v-model="form.name"
              @change="(e) => { formErr.name=''}"
              @blur="(e) => {  form.name = e.target.value.trim();}"
          />
        </a-form-model-item>
        <a-form-model-item
            ref="description"
            label="功能描述"
            prop="description"
            :help="formErr.description"
            :validateStatus='!formErr.description||formErr.description==""?"":"error"'
        >
          <a-input
              :maxLength=100
              v-model="form.description"
              @change="(e) => { formErr.description=''}"
              @blur="(e) => {  form.description = e.target.value.trim();}"
          />
        </a-form-model-item>

<template v-if="show==1">
  <a-form-model-item
      ref="guide_language_one"
      label="功能引导语1"
      prop="guide_language_one"
      :help="formErr.guide_language_one"
      :validateStatus='!formErr.guide_language_one||formErr.guide_language_one==""?"":"error"'
  >
    <a-input
        v-model="form.guide_language_one"
        @change="(e) => { formErr.guide_language_one=''}"
        @blur="(e) => {  form.guide_language_one = e.target.value.trim();}"
    />
  </a-form-model-item>
  <a-form-model-item
      ref="guide_language_two"
      label="功能引导语2"
      prop="guide_language_two"
      :help="formErr.guide_language_two"
      :validateStatus='!formErr.guide_language_two||formErr.guide_language_two==""?"":"error"'
  >
    <a-input
        v-model="form.guide_language_two"
        @change="(e) => { formErr.guide_language_two=''}"
        @blur="(e) => {  form.guide_language_two = e.target.value.trim();}"
    />
  </a-form-model-item>
</template>

<div style="position: relative">

  <a-form-model-item
    ref="image"
    prop="image"
    :extra="formErr.image"
    :validateStatus='!formErr.image||formErr.image==""?"":"error"'

>
    <span slot="label" > <i class="xing">*</i>功能图标</span>
  <a-upload
      :action="this.$store.state.urlChang"
      :data="{type:1}"
      :file-list="fileList"
      :headers="headers"
      @change="(file)=>{handleChange(file)}"
      :before-upload="beforeUpload"
      @preview="handlePreview"
      :remove="handleRemove"
      list-type="picture-card"
      name="file"
  >
    <div v-if="fileList.length < 1">
      <a-icon type="plus"/>
      <div class="ant-upload-text">Upload</div>
    </div>
  </a-upload>
  <a-modal :footer="null" :visible="previewVisible" @cancel="handleCancel">
    <img :src="previewImage" alt="example" style="width: 100%"/>
  </a-modal>

</a-form-model-item>
</div>


        <template v-if="show==2">
          <a-form-model-item
              ref="guide_language_one"
              label="功能引导语"
              prop="guide_language_one"
              :help="formErr.guide_language_one"
              :validateStatus='!formErr.guide_language_one||formErr.guide_language_one==""?"":"error"'
          >
            <a-input
                v-model="form.guide_language_one"
                @change="(e) => { formErr.guide_language_one=''}"
                @blur="(e) => {  form.guide_language_one = e.target.value.trim();}"
            />
          </a-form-model-item>
          <a-form-model-item
              ref="instruct"
              label="指令设置"
              prop="instruct"
              :help="formErr.instruct"
              :validateStatus='!formErr.instruct||formErr.instruct==""?"":"error"'
          >
            <a-input
                v-model="form.instruct"
                @change="(e) => { formErr.instruct=''}"
                @blur="(e) => {  form.instruct = e.target.value.trim();}"
            />
          </a-form-model-item>
          <a-form-model-item
              ref="lang"
              label="语种设置"
              prop="lang"
              :help="formErr.lang"
              :validateStatus='!formErr.lang||formErr.lang==""?"":"error"'
          >
            <a-input
                v-model="form.lang"
                @change="(e) => { formErr.lang=''}"
                @blur="(e) => {  form.lang = e.target.value.trim();}"
            />
          </a-form-model-item>
        </template>

        <a-form-model-item
            label=" "
            :colon="false"
        >
          <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
            保存
          </a-button>
          <a-button @click="onClose">
            返回
          </a-button>
        </a-form-model-item>



      </a-form-model>

    </div>
</template>

<script>
    import API from "./api";
    import {drawerConfig, submitForm, validator} from "../../../../../utils/utils";
    function getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    }

    export default {
        name: "index",

      data() {
        return {
          show:this.$route.query.show,
          type:this.$route.query.type,
          contenta: "",
          headers: {Authorization: window.sessionStorage.getItem("signature")},
          seleList:[],
          fileList:[],
          previewVisible: false,
          previewImage: "",
          drawerConfig ,
          form: {
            name:"",
            guide_language_one:"",
            image:"",
            guide_language_two:"",
            description:'',
            lang:'',
            instruct:''
          },
          formErr: {
            name:"",
            guide_language_one:"",
            image:"",
            guide_language_two:"",
            description:'',
            lang:'',
            instruct:''
          },
          rules: {
            name: [{required: true, message: "请输入功能名称",  },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.name)}  , trigger: "blur"  },],
            description: [{required: true, message: "请输入功能描述",  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.description)}  , trigger: "blur"  },],
            lang: [{required: this.$route.query.show==2?true:false, message: "请输入语种设置",  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.lang)}  , trigger: "blur"  },],
            instruct: [{required: this.$route.query.show==2?true:false, message: "请输入指令设置",  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.instruct)}  , trigger: "blur"  },],
            guide_language_one: [{required: this.$route.query.show==2?true:false, message: "请输入功能引导语",  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.guide_language_one)}  , trigger: "blur"  },],

            // image:[{required: true, message: "请上传功能图标", trigger: "change"  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.image)}  , trigger: "change"  },],
          },
          layout: {
            labelCol: { span:3},
            wrapperCol: { span: 20 },
          },
        };

      },

      mounted(){
        this.getData()
      },
      methods: {
        onClose(){this.$router.push("/ai/assistant")},
          getData(){
            API.service.GET_DATA({id:this.$route.query.id}).then(res => {
              let data=res.data.data
              this.form = data
              if (this.form.image == "") {
                this.fileList = []
              } else {
                this.fileList = [
                  {uid: this.form.image,
                    name: this.form.image,
                    status: "done",
                    url: this.form.image ? this.form.image : ""
                  }
                ]
              }

            })
          },

        handleRemove(){this.fileList=[],this.form.image="";},
        handleCancel() {
          this.previewVisible = false;
        },
        handleChange(info ) {
          let {fileList} = info;
          const status = info.file.status;

          if (status !== 'uploading') {
            this.fileList=[]
          }
          if (status === 'done') {
            this.formErr.image=""
            this.fileList= fileList
          } else if (status === 'error') {
          }
          if (status === 'uploading') {
            this.fileList= fileList
          }
          if (status=== 'done') {
            getBase64(info.file.originFileObj, imageUrl => {
              this.formErr.image=""
              this.fileList= fileList
            });
          }
          //重新设置state
          // this.setState( {fileList});
        },
        beforeUpload(file) {
          const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
          if (!isJpgOrPng) {
            this.$message.error('只能上传jpeg,jpg，png类型图片!');
            return false
          }
          const isLt2M = file.size / 1024 / 1024 < 1;
          if (!isLt2M) {
            this.$message.error('图片必须小于 1MB!');
            return false
          }
          return new Promise(function (resolve,reject) {
            resolve(file)
          })
        },
        async handlePreview(file) {
          if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
          }
          this.previewImage = file.url || file.preview;
          this.previewVisible = true;
        },
        onSubmit() {
          let _this = this;
      console.log("this.fileList",this.fileList)
          console.log("this.image",this.image)
          if (this.fileList.length < 1) {
            _this.formErr.image = "请上传功能图标";
return
          } else {
            _this.formErr.image = "";
            this.form.image = this.fileList[0].url
          }
          if (this.fileList.length > 0 && this.fileList[0].url) {
            this.form.image = this.fileList[0].url
          } else if (this.fileList.length > 0 && this.fileList[0].response) {
            this.form.image = this.fileList[0].response.data.url
          } else {
            this.form.image = ""
          }
          this.$refs.ruleForm.validate(valid => {
            if (valid) {
              let url
              let subData=JSON.parse(JSON.stringify(this.form))

                  url = API.service.SUBMIT_EDIT
              submitForm(url, subData).then(res => {
                if (res == true) {
                this.onClose()
                  // this.getData()
                } else {
                  res.map((item, index) => {
                    this.formErr[item.field] = item.msg
                  })
                }
              })
            } else {
              return false;
            }
          });
        },
      },
    }
</script>

<style scoped>
    .seachBox .seachList .name {
        width: 70px !important;
    }

    .seachBox .seachList .seachs {
        width: calc(100% - 80px);
    }

    .inputs {
        display: inline-block;
        width: 70px
    }
    .xing{ color: #f5222d;
      font-size: 14px;margin-right: 2px}
</style>
